var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('input',{staticClass:"form-control-file",attrs:{"type":"file","id":_vm.id,"accept":".zip,.mdb,.accdb"},on:{"change":function($event){return _vm.updateValue($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }